import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { sharedConstants } from 'src/environments/constants';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-unauthorized.page.',
  templateUrl: './unauthorized.page.component.html',
  styleUrls: ['./unauthorized.page.component.sass'],
})
export class UnauthorizedPageComponent implements OnInit {
  stringModule = 'Nuestros Productos';
  hideButton: boolean;
  constructor(public route: ActivatedRoute, private router: Router) {
    const dataExtra = this.router.getCurrentNavigation();
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });
    if (dataExtra !== null) {
// eslint-disable-next-line no-prototype-builtins
      if (dataExtra.hasOwnProperty('extras') && dataExtra.extras.hasOwnProperty('state') && dataExtra.extras.state.hasOwnProperty('data')) {
        const contextPath = this.router.getCurrentNavigation().extras.state.contextPath;
        this.stringModule = this.router.getCurrentNavigation().extras.state.data;
        this.hideButton = sharedConstants.hideUnauthorizedButton.includes(contextPath);
      }
    }
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * method to redirect to principal mu web
   */
  redirect(): void {
    location.href = environment.principalMULink;
  }
}
